import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";
import GitHubIcon from "@material-ui/icons/GitHub";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

function Project2({ title, description, technologies, link, img, gitlink }) {
  return (
    <div className="row project__showcase">
      <div className="col-md-5 project__description" style={{ padding: "0" }}>
        <div className="descrtiption__title">
          <h6
            style={{
              marginLeft: "0",
              "@media (max-width: 900px)": {
                marginLeft: "10px",
              },
            }}
          >
            Featured Project
          </h6>
          <h2 style={{ marginLeft: "0" }}>{title}</h2>
        </div>
        <div
          className="description"
          style={{ left: "0", marginRight: "-120px", marginLeft: "0" }}
        >
          <p>{description}</p>
        </div>
        <p className="tech__description" style={{ marginLeft: "0", width: "" }}>
          {technologies}
        </p>
        <span
          className="description__icons"
          style={{ marginLeft: "0", marginRight: "auto" }}
        >
          <a href={gitlink}>
            <GitHubIcon />
          </a>
          <a href={link}>
            <OpenInNewIcon />
          </a>
        </span>
      </div>
      <a
        href={link}
        target="_blank"
        className="col-md-7 project__img"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div />
      </a>
    </div>
  );
}

export default Project2;
